import {
  FileList,
  FileListButton,
  Paragraph,
} from "@george-labs.com/design-system"
import { DocumentDTO, GetContentRq } from "@smartx/mikro-vt-client-api"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router"
import { saveAs } from "file-saver"
import { setActive } from "../../../app/slices/snackbarItemSlice"
import { store } from "../../../app/store"
import CollapsibleComponent from "../../../components/Collapsible/Collapsible"
import * as fileHandler from "../../../functions/fileHandler"
import { ModalComponent } from "../../../Shared"
import { RequestHeader } from "../../../utils/utils"
import { fileNetApi } from "../../../api/apiClient"

interface ITempArr {
  name: string
  filenetId: string
  type: string
}

interface IDocsGroup {
  type: string
  documents: DocumentDTO[]
  name: string
}

const OverviewDocuments = (props: any) => {
  const { t } = useTranslation()
  const [files, setFiles] = useState<Array<ITempArr>>([])
  const [downloadErr, setDownloadErr] = useState<boolean>(false)
  const [onlineDocuments, setOnlineDocuments] = useState<Array<DocumentDTO>>([])
  const [branchDocuments, setBranchDocuments] = useState<Array<IDocsGroup>>([])
  const { caseId } = useParams<{ caseId: string }>()

  const fillFileArr = (arr: Array<DocumentDTO>) => {
    let tempArr: Array<ITempArr> = []
    arr.forEach((document) => {
      tempArr.push({
        name: document.fileName,
        filenetId: document.filenetId,
        type: document.type.type,
      })
    })
    setFiles(tempArr)
  }

  useEffect(() => {
    setOnlineDocuments(
      props.overviewData.filter(
        (item: DocumentDTO) => item.type.type === "ONLINE_HIANYPOTLAS",
      ),
    )

    const docs: IDocsGroup[] = []

    props.overviewData
      .filter((item: DocumentDTO) => item.type.type !== "ONLINE_HIANYPOTLAS")
      .sort((a: DocumentDTO, b: DocumentDTO) => {
        return a.type.name.localeCompare(b.type.name)
      })
      .forEach((doc: DocumentDTO) => {
        const existingDocType = docs.find((el) => el.type === doc.type.type)

        if (existingDocType) {
          existingDocType.documents.push(doc)
        } else {
          docs.push({
            documents: [doc],
            type: doc.type.type,
            name: doc.type.name,
          })
        }
      })
    setBranchDocuments(docs)
    fillFileArr(props.overviewData ? props.overviewData : [])
  }, [props.overviewData])

  const renderDownloadButton = (file: any) => (
    <FileListButton
      icon={FileListButton.ICON.FILE_DOWNLOAD}
      onClick={() => downloadFile(file)}
    >
      {t("documents.download.aria")}
    </FileListButton>
  )

  const downloadFile = (item: any) => {
    store.dispatch(setActive(true))

    const file = fileHandler.getFileByFilenetId(
      item.filenetId,
      props.overviewData,
    )
    const data: GetContentRq = {
      header: new RequestHeader(),
      objectId: file.filenetId,
      caseId: caseId,
      fileNetStorage: "EBH_BUSINESS",
      loanCaseEventId: file.loanCaseEventId,
    }

    fileNetApi.getContent(data).then(
      (res) => {
        store.dispatch(setActive(false))
        const blobFile = fileHandler.base64toBlob(
          res.data.content,
          res.data.mimeType,
        )
        saveAs(blobFile, file.fileName)
      },
      () => {
        store.dispatch(setActive(false))
        setDownloadErr(true)
      },
    )
  }

  return (
    <>
      {props.type === "online" && (
        <FileList
          files={files.filter((item) => item.type === "ONLINE_HIANYPOTLAS")}
          showRemoveButton={false}
          renderExtraButtons={renderDownloadButton}
        ></FileList>
      )}
      {props.type === "online" && onlineDocuments?.length === 0 && (
        <div className="text-center g-fg-ui-yellow">
          <Paragraph className="m-3">{t("documents.noFile")}</Paragraph>
        </div>
      )}
      {props.type === "branch" &&
        branchDocuments.map((docGroup: IDocsGroup) => {
          return (
            <div key={docGroup.type}>
              <CollapsibleComponent
                titleString={docGroup.name}
                content={
                  <FileList
                    files={files.filter((item) => item.type === docGroup.type)}
                    showRemoveButton={false}
                    renderExtraButtons={renderDownloadButton}
                  ></FileList>
                }
              ></CollapsibleComponent>
            </div>
          )
        })}
      {props.type === "branch" && branchDocuments?.length === 0 && (
        <div className="text-center g-fg-ui-yellow">
          <Paragraph className="m-3">{t("documents.noFile")}</Paragraph>
        </div>
      )}
      {downloadErr && (
        <ModalComponent
          type="error"
          title={t("common.warning.title")}
          text={t("documents.file-upload.error.default")}
          onClick={() => setDownloadErr(false)}
          onClose={() => setDownloadErr(false)}
          disableCancel={true}
        />
      )}
    </>
  )
}

export default OverviewDocuments
